<template>
    <div v-if="visible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" @keydown.esc="cancel">
        <div class="bg-ui-bg border border-ui-active/30 rounded-lg shadow-xl w-96 p-4 space-y-4 text-white text-sm">
            <div class="flex justify-between items-center">
                <span class="font-bold text-base">Save as Custom Component</span>
                <button @click="cancel" class="text-white/50 hover:text-white">✕</button>
            </div>

            <!-- Icon upload + preview -->
            <div class="flex items-center gap-3">
                <icon-editor v-model="iconBase64" :size="64" />
                <span class="text-white/50 text-xs">Component icon</span>
            </div>

            <!-- Name -->
            <div class="space-y-1">
                <label class="text-white/50 text-xs">Name <span class="text-red-400">*</span></label>
                <input v-model="name" type="text" placeholder="My Component"
                    class="w-full bg-ui-bg-input border border-ui-active/30 rounded px-2 py-1 text-white text-sm focus:outline-none focus:border-ui-active"
                    @keydown.enter="save" />
            </div>

            <!-- Description -->
            <div class="space-y-1">
                <label class="text-white/50 text-xs">Description</label>
                <textarea v-model="description" rows="3" placeholder="What does this component do?"
                    class="w-full bg-ui-bg-input border border-ui-active/30 rounded px-2 py-1 text-white text-sm focus:outline-none focus:border-ui-active resize-none" />
            </div>

            <div v-if="error" class="text-red-400 text-xs">{{ error }}</div>

            <!-- Actions -->
            <div class="flex justify-end gap-2">
                <button @click="cancel"
                    class="px-3 py-1 rounded bg-white/10 hover:bg-white/20">Cancel</button>
                <button @click="save"
                    class="px-3 py-1 rounded bg-ui-active text-ui-bg font-semibold hover:opacity-90">Save</button>
            </div>
        </div>
    </div>
</template>

<script>
import IconEditor from '../form/IconEditor.vue';

export default {
    name: 'SaveCustomComponentDialog',
    components: { IconEditor },
    props: {
        visible:   { type: Boolean, default: false },
        thumbnail: { type: String,  default: null  },
    },
    emits: ['save', 'cancel'],
    data() {
        return {
            name: '',
            description: '',
            iconBase64: null,
            error: '',
        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.name        = '';
                this.description = '';
                this.iconBase64  = this.thumbnail;
                this.error       = '';
            }
        },
    },
    methods: {
        save() {
            this.error = '';
            if (!this.name.trim()) {
                this.error = 'Name is required.';
                return;
            }
            this.$emit('save', {
                name: this.name.trim(),
                description: this.description.trim(),
                icon: this.iconBase64,
            });
        },
        cancel() {
            this.$emit('cancel');
        },
    },
};
</script>
